module.exports = __webpack_public_path__ + "img/bicing-0.64455930.svg";